import React from "react";
import { STHeroCommon } from "../STHeroCommon";
import { Icons } from "@/const/icons";
import Link from "next/link";
import clsx from "clsx";
import styles from "./STPrivacyPolicy.module.css";

export const STPrivacyPolicy = () => {
  return (
    <>
      <STHeroCommon title={"Privacy Policy"} />
      <section className={clsx("space-xl-py")}>
        <div className="container">
          <Link
            href="/"
            className={clsx(
              styles.backBtn,
              "d-inline-flex align-items-center gap-2 space-sm-mb",
            )}
          >
            {Icons.arrowLeft}
            <span>Go back</span>
          </Link>
          <p className="space-sm-mb h6 lh-base fw-normal">
            Sustanix Materialtech BV, the company which owns all the rights for
            brand Sustanix and its subsidiaries/affiliates is pleased that you
            have visited our website and are interested in our company, products
            and services. It is important to us to protect your personal data
            during handling throughout the entire business process.
          </p>
          <h4 className="section-title space-sm-mb">Visiting our website</h4>
          <p className="space-sm-mb h6 lh-base fw-normal">
            Sustanix is committed to preserving the privacy of users of our
            websites. When you visit our web pages, The following data are
            collected: IP address, hostname of the accessing computer, website
            from which you accessed this website, a list of the sites you
            visited within the scope of our overall Internet presence, the date
            and duration of your visit, notification of whether the visit was
            successful, volume of data transferred, information about the
            identification data of the browser type and operating system used by
            you. Temporary storage of this data is necessary during your visit
            to the website in order to allow the website to be delivered to you.
            Further storage in log files is performed to ensure the
            functionality of the website and the security of our IT systems. The
            legal basis for the processing of the aforementioned data categories
            is therefore Art. 6 (1) (f) of the European General Data Protection
            Regulation (GDPR). Due to the said purposes, in particular to
            guarantee security and a smooth connection setup, we have a
            legitimate interest to process this data.
          </p>
          <p className="space-sm-mb h6 lh-base fw-normal">
            Additional personal information such as your name, address,
            telephone number or e-mail address is not collected unless you
            provide this data voluntarily, e.g. while completing an online
            contact form, as part of a registration, survey, competition or an
            information request.
          </p>
          <p className="space-sm-mb h6 lh-base fw-normal">
            The data are deleted as soon as they are no longer needed to achieve
            the purpose for which they were collected. For the provision of the
            website, this is the case when the session terminates. The log files
            (access logs) are kept for administrators to access directly and
            exclusively for a period of 24 hours. After that, they are only
            available indirectly through a restore from backup tapes and are
            permanently deleted after 30 days.{" "}
          </p>
          <p className="space-sm-mb h6 lh-base fw-normal">
            As far as you have enabled geo localization functions in your
            browser, respectively in your operating system we will use this data
            to offer you location-based services (e.g. location of the nearest
            branch, packing station etc.). The legal basis for geo-localization
            is your consent according Art. 6 (1) (a) GDPR by enabling the
            respective function. We will not use this data for any other
            purpose. If you disable this function your data will be deleted in
            due time.{" "}
          </p>
          <h4 className="section-title space-sm-mb">Use of cookies</h4>
          <p className="space-sm-mb h6 lh-base fw-normal">
            This website uses cookies and similar technologies, (hereafter
            “technologies”), which enable us, for example, to determine how
            frequently our internet pages are visited, the number of visitors,
            to configure our offers for maximum convenience and efficiency and
            to support our marketing efforts.{" "}
          </p>
          <p className="space-sm-mb h6 lh-base fw-normal">
            When you access our website, a Privacy Preference Centre will inform
            you that technically necessary cookies are set and, in addition,
            that your consent is required to the use of certain technologies,
            such as analytical cookies or similar technologies.
          </p>
          <p className="space-sm-mb h6 lh-base fw-normal">
            The processing of data by means of technically necessary cookies is
            based on our legitimate interest according to Art. 6 (1) f) GDPR to
            ensure that you can use our website the best possible way, to ensure
            that our website operates correctly and to guarantee an convenient
            and undisturbed user experience. These kinds of cookies are stored
            exclusively for the duration of your visit to our website. They are
            automatically deleted when you close your browser.
          </p>
          <p className="space-sm-mb h6 lh-base fw-normal">
            In addition, you will be informed via the Privacy Preference Centre 
            that we use other technologies (performance, functional or analytics
            technologies) for storing information about visitors who repeatedly
            access one of our internet pages. The purpose of using these
            technologies is to be able to offer you optimal user guidance as
            well as to "recognize" you and thus be able to present (as much as
            possible) diversified internet pages and new contents during
            repeated use. These technologies will only be processed on the basis
            of your prior given consent according to Art. 6 (1) a) GDPR.{" "}
          </p>
          <p className="space-sm-mb h6 lh-base fw-normal">
            You will find more information under the Privacy Preference Centre 
            including the option to revoke a given consent.{" "}
          </p>
          <p className="mb-0 h6 lh-base fw-normal">
            Notwithstanding the information in the Preference Centre, and only
            if you have consented to the use of cookies and other technologies
            as described above, we also use them for the purposes described
            below.
          </p>
        </div>
      </section>
    </>
  );
};
